'use strict';

function rememberPulseScroll(win = globalThis) {
  const y = Number(win && win.scrollY);
  return Number.isFinite(y) ? y : 0;
}

function restorePulseScroll(win = globalThis, y = 0) {
  if (!win || typeof win.scrollTo !== 'function') return;
  const top = Number(y);
  win.scrollTo(0, Number.isFinite(top) ? top : 0);
}

export { rememberPulseScroll, restorePulseScroll };
